<template>
  <div class="post">
    <div v-if="loading" class="loading">Cargando...</div>
    <div v-else-if="error" class="error">No se pudo cargar el post.</div>
    <div v-else>
      <div v-html="content" class="post-content"></div>
      <div class="buttons">
        <router-link to="/blog" class="btn btn-back">Regresar a la lista de posts</router-link>
        <button @click="scrollToContact" class="btn btn-cta">Ir al formulario</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { marked } from 'marked';

export default {
  name: 'VxPost',
  setup() {
    const route = useRoute();
    const content = ref('');
    const loading = ref(true);
    const error = ref(false);

    onMounted(async () => {
      const fileName = route.params.id;
      const postUrl = `/post/${fileName}`;

      try {
        const response = await fetch(postUrl);
        if (!response.ok) {
          throw new Error('Post no encontrado');
        }
        const text = await response.text();
        content.value = marked(text);
      } catch (error) {
        console.error('Error al cargar el post:', error);
        error.value = true;
      } finally {
        loading.value = false;
      }
    });

    const scrollToContact = () => {
      const contactElement = document.getElementById('contact');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth' });
      }
    };

    return {
      content,
      loading,
      error,
      scrollToContact
    };
  }
};
</script>

<style scoped>
.post {
  padding: 20px;
  max-width: 800px;
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
}

.loading, .error {
  text-align: center;
  font-size: 1.2rem;
  margin-top: 20px;
}

.error {
  color: #d9534f; /* Color de error rojo */
}

.post-content {
  font-size: 1rem;
  line-height: 1.6;
}

h1, h2, h3, h4, h5, h6 {
  color: #000; /* Color de los encabezados, ajustar según diseño */
}

a {
  color: #0275d8; /* Color de enlaces, ajustar según diseño */
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  color: #fff;
}

.btn-back {
  background-color: #5bc0de; /* Ajusta el color según tu diseño */
}

.btn-cta {
  background-color: #5cb85c; /* Ajusta el color según tu diseño */
}
</style>
